

export const truncateInputValue = (limit) => (event) => {
  const value = event?.target?.value

  if ( value && value.length > limit ) {
    event.target.value = value.slice(0, limit)
  }
}